import { addOrUpdateCampaign } from '../../apiClient';
import { notifications } from '@mantine/notifications';
import { useEntityQueryUpdate } from '../../../hooks/useEntityQueryUpdate';
import { useMutation } from '@tanstack/react-query';

const useAddCampaign = () => {
    const entityUpdater = useEntityQueryUpdate();

    const mutation = useMutation({
        mutationKey: 'add_campaign',
        mutationFn: (model) => addOrUpdateCampaign(model),
        onSuccess: (data) => {
            entityUpdater([['campaigns'], ['campaign', data.id]], data);
            notifications.show({
                title: 'Success',
                message: `Successfully ${
                    data.id ? 'updated' : 'created'
                } campaign`,
                color: 'green',
            });
        },
        onError: (error) => {
            notifications.show({
                title: 'Error',
                message: error.message,
                color: 'red',
            });
        },
    });
    return mutation;
};
export default useAddCampaign;
